import { render, staticRenderFns } from "./SapFilters.vue?vue&type=template&id=22e2da0c&scoped=true"
import script from "./SapFilters.vue?vue&type=script&lang=js"
export * from "./SapFilters.vue?vue&type=script&lang=js"
import style0 from "./SapFilters.vue?vue&type=style&index=0&id=22e2da0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2da0c",
  null
  
)

export default component.exports